// extracted by mini-css-extract-plugin
export var section = "_52-1";
export var topNav = "_52-0";